/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  CalculateSessionRequest,
  CalculateTuitionRequest,
  CalculationType,
  CreateCalculationCycleRequest,
  CreateCalculationResponse,
  CurrentTuitionPostingResponse,
  GetCalculationCycleRequest,
  GetCalculationCycleResponse,
  PaginatedResultOfGetCalculationCycleResponse,
  Result,
  SetCalculationCycleDetailNoteRequest,
  StartCalculationRequest,
  TuitionCalculationCandidate,
  UpdateCalculationCycleRequest,
} from '../models/index';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    CalculateSessionRequestFromJSON,
    CalculateSessionRequestToJSON,
    CalculateTuitionRequestFromJSON,
    CalculateTuitionRequestToJSON,
    CalculationTypeFromJSON,
    CalculationTypeToJSON,
    CreateCalculationCycleRequestFromJSON,
    CreateCalculationCycleRequestToJSON,
    CreateCalculationResponseFromJSON,
    CreateCalculationResponseToJSON,
    CurrentTuitionPostingResponseFromJSON,
    CurrentTuitionPostingResponseToJSON,
    GetCalculationCycleRequestFromJSON,
    GetCalculationCycleRequestToJSON,
    GetCalculationCycleResponseFromJSON,
    GetCalculationCycleResponseToJSON,
    PaginatedResultOfGetCalculationCycleResponseFromJSON,
    PaginatedResultOfGetCalculationCycleResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
    SetCalculationCycleDetailNoteRequestFromJSON,
    SetCalculationCycleDetailNoteRequestToJSON,
    StartCalculationRequestFromJSON,
    StartCalculationRequestToJSON,
    TuitionCalculationCandidateFromJSON,
    TuitionCalculationCandidateToJSON,
    UpdateCalculationCycleRequestFromJSON,
    UpdateCalculationCycleRequestToJSON,
} from '../models/index';

export interface ApiTuitionCalculationCyclesCurrentTypeGetRequest {
    type: CalculationType;
    xTenantID?: number;
}

export interface ApiTuitionCalculationCyclesDetailIdNotePutRequest {
    id: number;
    setCalculationCycleDetailNoteRequest: SetCalculationCycleDetailNoteRequest;
    xTenantID?: number;
}

export interface ApiTuitionCalculationCyclesHistoryPostRequest {
    getCalculationCycleRequest: GetCalculationCycleRequest;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiTuitionCalculationCyclesIdCalculatePostRequest {
    id: number;
    startCalculationRequest: StartCalculationRequest;
    xTenantID?: number;
}

export interface ApiTuitionCalculationCyclesIdCandidatesGetRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiTuitionCalculationCyclesIdClosePutRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiTuitionCalculationCyclesIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiTuitionCalculationCyclesIdGetRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiTuitionCalculationCyclesIdPostPostRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiTuitionCalculationCyclesIdPutRequest {
    id: number;
    updateCalculationCycleRequest: UpdateCalculationCycleRequest;
    xTenantID?: number;
}

export interface ApiTuitionCalculationCyclesPostRequest {
    createCalculationCycleRequest: CreateCalculationCycleRequest;
    xTenantID?: number;
}

export interface ApiTuitionPreviewPostRequest {
    calculateTuitionRequest: CalculateTuitionRequest;
    xTenantID?: number;
}

export interface ApiTuitionSessionsPreviewPostRequest {
    calculateSessionRequest: CalculateSessionRequest;
    xTenantID?: number;
}

/**
 * 
 */
export class TuitionApi extends runtime.BaseAPI {

    /**
     * Gets current calculation cycle.
     * Get current calculation cycle
     */
    async apiTuitionCalculationCyclesCurrentTypeGetRaw(requestParameters: ApiTuitionCalculationCyclesCurrentTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCalculationCycleResponse>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling apiTuitionCalculationCyclesCurrentTypeGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition/calculation-cycles/current/{type}`;
        urlPath = urlPath.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCalculationCycleResponseFromJSON(jsonValue));
    }

    /**
     * Gets current calculation cycle.
     * Get current calculation cycle
     */
    async apiTuitionCalculationCyclesCurrentTypeGet(requestParameters: ApiTuitionCalculationCyclesCurrentTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCalculationCycleResponse> {
        const response = await this.apiTuitionCalculationCyclesCurrentTypeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets or updates the note for the specified calculation cycle detail.
     * Set calculation cycle detail note
     */
    async apiTuitionCalculationCyclesDetailIdNotePutRaw(requestParameters: ApiTuitionCalculationCyclesDetailIdNotePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTuitionCalculationCyclesDetailIdNotePut().'
            );
        }

        if (requestParameters['setCalculationCycleDetailNoteRequest'] == null) {
            throw new runtime.RequiredError(
                'setCalculationCycleDetailNoteRequest',
                'Required parameter "setCalculationCycleDetailNoteRequest" was null or undefined when calling apiTuitionCalculationCyclesDetailIdNotePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition/calculation-cycles/detail/{id}/note`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetCalculationCycleDetailNoteRequestToJSON(requestParameters['setCalculationCycleDetailNoteRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sets or updates the note for the specified calculation cycle detail.
     * Set calculation cycle detail note
     */
    async apiTuitionCalculationCyclesDetailIdNotePut(requestParameters: ApiTuitionCalculationCyclesDetailIdNotePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTuitionCalculationCyclesDetailIdNotePutRaw(requestParameters, initOverrides);
    }

    /**
     * Get calculation cycles.
     * Get calculation cycles
     */
    async apiTuitionCalculationCyclesHistoryPostRaw(requestParameters: ApiTuitionCalculationCyclesHistoryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetCalculationCycleResponse>> {
        if (requestParameters['getCalculationCycleRequest'] == null) {
            throw new runtime.RequiredError(
                'getCalculationCycleRequest',
                'Required parameter "getCalculationCycleRequest" was null or undefined when calling apiTuitionCalculationCyclesHistoryPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition/calculation-cycles/history`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetCalculationCycleRequestToJSON(requestParameters['getCalculationCycleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetCalculationCycleResponseFromJSON(jsonValue));
    }

    /**
     * Get calculation cycles.
     * Get calculation cycles
     */
    async apiTuitionCalculationCyclesHistoryPost(requestParameters: ApiTuitionCalculationCyclesHistoryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetCalculationCycleResponse> {
        const response = await this.apiTuitionCalculationCyclesHistoryPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Starts the tuition calculation process for the specified calculation cycle. The calculation is processed asynchronously in the background.
     * Start tuition calculation
     */
    async apiTuitionCalculationCyclesIdCalculatePostRaw(requestParameters: ApiTuitionCalculationCyclesIdCalculatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTuitionCalculationCyclesIdCalculatePost().'
            );
        }

        if (requestParameters['startCalculationRequest'] == null) {
            throw new runtime.RequiredError(
                'startCalculationRequest',
                'Required parameter "startCalculationRequest" was null or undefined when calling apiTuitionCalculationCyclesIdCalculatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition/calculation-cycles/{id}/calculate`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartCalculationRequestToJSON(requestParameters['startCalculationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Starts the tuition calculation process for the specified calculation cycle. The calculation is processed asynchronously in the background.
     * Start tuition calculation
     */
    async apiTuitionCalculationCyclesIdCalculatePost(requestParameters: ApiTuitionCalculationCyclesIdCalculatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTuitionCalculationCyclesIdCalculatePostRaw(requestParameters, initOverrides);
    }

    /**
     * Gets calculation cycle candidates.
     * Get calculation cycle candidates
     */
    async apiTuitionCalculationCyclesIdCandidatesGetRaw(requestParameters: ApiTuitionCalculationCyclesIdCandidatesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TuitionCalculationCandidate>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTuitionCalculationCyclesIdCandidatesGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition/calculation-cycles/{id}/candidates`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TuitionCalculationCandidateFromJSON));
    }

    /**
     * Gets calculation cycle candidates.
     * Get calculation cycle candidates
     */
    async apiTuitionCalculationCyclesIdCandidatesGet(requestParameters: ApiTuitionCalculationCyclesIdCandidatesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TuitionCalculationCandidate>> {
        const response = await this.apiTuitionCalculationCyclesIdCandidatesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Marks the specified calculation cycle as closed.
     * Close calculation cycle
     */
    async apiTuitionCalculationCyclesIdClosePutRaw(requestParameters: ApiTuitionCalculationCyclesIdClosePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTuitionCalculationCyclesIdClosePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition/calculation-cycles/{id}/close`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Marks the specified calculation cycle as closed.
     * Close calculation cycle
     */
    async apiTuitionCalculationCyclesIdClosePut(requestParameters: ApiTuitionCalculationCyclesIdClosePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTuitionCalculationCyclesIdClosePutRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes the specified calculation cycle and its associated calculation details.
     * Delete calculation cycle
     */
    async apiTuitionCalculationCyclesIdDeleteRaw(requestParameters: ApiTuitionCalculationCyclesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTuitionCalculationCyclesIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition/calculation-cycles/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the specified calculation cycle and its associated calculation details.
     * Delete calculation cycle
     */
    async apiTuitionCalculationCyclesIdDelete(requestParameters: ApiTuitionCalculationCyclesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTuitionCalculationCyclesIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Gets calculation cycle with details by ID.
     * Get calculation cycle by ID
     */
    async apiTuitionCalculationCyclesIdGetRaw(requestParameters: ApiTuitionCalculationCyclesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetCalculationCycleResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTuitionCalculationCyclesIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition/calculation-cycles/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetCalculationCycleResponseFromJSON(jsonValue));
    }

    /**
     * Gets calculation cycle with details by ID.
     * Get calculation cycle by ID
     */
    async apiTuitionCalculationCyclesIdGet(requestParameters: ApiTuitionCalculationCyclesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetCalculationCycleResponse> {
        const response = await this.apiTuitionCalculationCyclesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Posts the tuition calculation for the specified calculation cycle.
     * Post tuition calculation
     */
    async apiTuitionCalculationCyclesIdPostPostRaw(requestParameters: ApiTuitionCalculationCyclesIdPostPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTuitionCalculationCyclesIdPostPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition/calculation-cycles/{id}/post`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Posts the tuition calculation for the specified calculation cycle.
     * Post tuition calculation
     */
    async apiTuitionCalculationCyclesIdPostPost(requestParameters: ApiTuitionCalculationCyclesIdPostPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTuitionCalculationCyclesIdPostPostRaw(requestParameters, initOverrides);
    }

    /**
     * Update calculation cycle properties allowed only in Pending status.
     * Update calculation cycle
     */
    async apiTuitionCalculationCyclesIdPutRaw(requestParameters: ApiTuitionCalculationCyclesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTuitionCalculationCyclesIdPut().'
            );
        }

        if (requestParameters['updateCalculationCycleRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCalculationCycleRequest',
                'Required parameter "updateCalculationCycleRequest" was null or undefined when calling apiTuitionCalculationCyclesIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition/calculation-cycles/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCalculationCycleRequestToJSON(requestParameters['updateCalculationCycleRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update calculation cycle properties allowed only in Pending status.
     * Update calculation cycle
     */
    async apiTuitionCalculationCyclesIdPut(requestParameters: ApiTuitionCalculationCyclesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTuitionCalculationCyclesIdPutRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a new calculation cycle for the specified calculation period and billing frequency.
     * Create calculation cycle
     */
    async apiTuitionCalculationCyclesPostRaw(requestParameters: ApiTuitionCalculationCyclesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCalculationResponse>> {
        if (requestParameters['createCalculationCycleRequest'] == null) {
            throw new runtime.RequiredError(
                'createCalculationCycleRequest',
                'Required parameter "createCalculationCycleRequest" was null or undefined when calling apiTuitionCalculationCyclesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition/calculation-cycles`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCalculationCycleRequestToJSON(requestParameters['createCalculationCycleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCalculationResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new calculation cycle for the specified calculation period and billing frequency.
     * Create calculation cycle
     */
    async apiTuitionCalculationCyclesPost(requestParameters: ApiTuitionCalculationCyclesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCalculationResponse> {
        const response = await this.apiTuitionCalculationCyclesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Calculates and previews the tuition for a student based on the provided details.
     * Preview tuition for a student
     */
    async apiTuitionPreviewPostRaw(requestParameters: ApiTuitionPreviewPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CurrentTuitionPostingResponse>> {
        if (requestParameters['calculateTuitionRequest'] == null) {
            throw new runtime.RequiredError(
                'calculateTuitionRequest',
                'Required parameter "calculateTuitionRequest" was null or undefined when calling apiTuitionPreviewPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition/preview`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CalculateTuitionRequestToJSON(requestParameters['calculateTuitionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CurrentTuitionPostingResponseFromJSON(jsonValue));
    }

    /**
     * Calculates and previews the tuition for a student based on the provided details.
     * Preview tuition for a student
     */
    async apiTuitionPreviewPost(requestParameters: ApiTuitionPreviewPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CurrentTuitionPostingResponse> {
        const response = await this.apiTuitionPreviewPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Calculates and previews the private lessons charges for a student based on the provided details.
     * Preview private lesson charges for a student
     */
    async apiTuitionSessionsPreviewPostRaw(requestParameters: ApiTuitionSessionsPreviewPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CurrentTuitionPostingResponse>> {
        if (requestParameters['calculateSessionRequest'] == null) {
            throw new runtime.RequiredError(
                'calculateSessionRequest',
                'Required parameter "calculateSessionRequest" was null or undefined when calling apiTuitionSessionsPreviewPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition/sessions/preview`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CalculateSessionRequestToJSON(requestParameters['calculateSessionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CurrentTuitionPostingResponseFromJSON(jsonValue));
    }

    /**
     * Calculates and previews the private lessons charges for a student based on the provided details.
     * Preview private lesson charges for a student
     */
    async apiTuitionSessionsPreviewPost(requestParameters: ApiTuitionSessionsPreviewPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CurrentTuitionPostingResponse> {
        const response = await this.apiTuitionSessionsPreviewPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
